<script>
  import { asteroid } from "@/meteor.js";
  import { fade } from "svelte/transition";
  export let receive, send, user, userId;
  let password = "";
  let email = "";

  function create() {
    asteroid.call("user.create", { email, password });
  }
</script>

<div class="fixed inset-0 flex flex-wrap justify-center content-center">
  <div
    class="backdrop"
    on:click={() => history.pushState({}, '', '/users')}
    in:fade
    out:fade />
  <div
    class="bg-white w-1/2 relative shadow-xl px-16 py-8 text-center rounded-lg
    text-xl"
    in:receive={{ key: 'newUser' }}
    out:send={{ key: 'newUser' }}>
    <div>
      <div class="">
        <label for="email" class="pr-4 w-48 inline-block text-right">Email</label>
        <input
          type="text"
          id="email"
          bind:value={email}
          class="shadow-inner text-xl bg-gray-100" />
      </div>
      <div class="py-8">
        <label for="password" class="pr-4 w-48 inline-block text-right">Adgangskode</label>
        <input
          type="password"
          id="password"
          bind:value={password}
          class="shadow-inner text-xl bg-gray-100" />
      </div>
    </div>

    <div class="h-12">
      {#if password && email}
        <button on:click={create} class="btn green solid">
          Opret
        </button>
      {/if}
    </div>

  </div>
</div>
